var _circle, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealestate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FFE5A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0735 10.7734H17.4683C16.7461 10.7734 16.1465 11.3028 16.0547 11.9852H23.4873C23.3955 11.3029 22.7957 10.7734 22.0736 10.7734H22.0735Z",
    fill: "#093851"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19922 8.20312H15.6564V9.29862H8.19922V8.20312Z",
    fill: "#093851"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21216 18.6695H11.0787V22.372H15.6563L15.6564 9.67969H8.19922V22.372H9.21199L9.21216 18.6695ZM12.9911 11.185H14.4324V13.2658H12.9911V11.185ZM12.9911 14.814H14.4324V16.8948H12.9911V14.814ZM12.9911 18.446H14.4324V20.5268H12.9911V18.446ZM9.42635 11.185H10.8676V13.2658H9.42635V11.185ZM9.42635 14.814H10.8676V16.8948H9.42635V14.814Z",
    fill: "#093851"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9969 19.2765C16.9969 18.8849 17.4405 18.5635 17.9852 18.5635C18.5299 18.5635 18.9736 18.8818 18.9736 19.2765V22.3731H23.4962V12.3672H16.0391V22.3731H16.9968L16.9969 19.2765ZM20.8278 14.2982C20.8278 13.9065 21.1521 13.5852 21.5468 13.5852C21.9446 13.5852 22.2659 13.9034 22.2659 14.2982V16.5044H20.8246V14.2982H20.8278ZM20.8278 19.1574C20.8278 18.7658 21.1521 18.4444 21.5468 18.4444C21.9446 18.4444 22.2659 18.7626 22.2659 19.1574V20.5251H20.8246V19.1574H20.8278ZM17.266 14.2982C17.266 13.9065 17.5903 13.5852 17.9851 13.5852C18.3798 13.5852 18.7041 13.9034 18.7041 14.2982V16.5044H17.2629V14.2982H17.266Z",
    fill: "#093851"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19922 22.7109H23.4987V23.5034H8.19922V22.7109Z",
    fill: "#093851"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealestate);
export default __webpack_public_path__ + "static/media/realestate.a20af46ca69fb92101c41b3836cd73ca.svg";
export { ForwardRef as ReactComponent };